<template>
	<div class="container">
		<div class="row">
			<div class="col-sm-6 col-md-7 col-lg-7">
				<div class="card mb-3">
					<div class="card-body">
						<form @submit.prevent="buscar_producto">
							<div class="form-check form-check-inline" v-for="(i, pidx) in ops_producto" :key="pidx">
								<input
									class="form-check-input"
									type="radio"
									name="pro_opcion"
									:value="i.id"
									:id="'tipo-'+i.id"
									v-model="pform.tipo"
								>
								<label class="form-check-label" :for="'tipo-'+i.id">{{ i.text }}</label>
							</div>
							<div class="input-group mb-3">
								<input
									type="text"
									class="form-control"
									placeholder="Buscar por código o descripción"
									aria-label="Buscar por código o descripción"
									aria-describedby="button-search-sku"
									v-model="pform.texto"
									:minlength="pform.tipo == 1 ? 1 : 3"
								>
								<div class="input-group-append">
									<button
										class="btn btn-outline-secondary"
										type="submit"
										id="button-search-sku"
									>Buscar</button>
								</div>
							</div>
						</form>
						<hr>
						<div class="card mb-3">
							<div class="card-body" v-if="prob">
								<p class="card-text">Buscando...</p>
							</div>

							<div
								href="#"
								class="row no-gutters"
								v-for="(i, pidx) in productos" :key="pidx"
							>
								<div class="col-md-4">
									<img :src="imagen(pidx)" class="img-fluid" :alt="i.nombre">
								</div>
								<div class="col-md-8">
									<div class="card-body">
										<h5 class="card-title">{{ i.codigo }} - {{ i.nombre }}</h5>
										<p class="card-text"><small class="text-muted">{{ i.ncategoria }}</small></p>
										<p class="card-text">{{ i.descripcion }}</p>
										<p class="card-text"><small class="text-muted">{{ i.nproveedor }}</small></p>
										<a href="#" class="btn btn-sm btn-primary" @click.prevent="addItem(pidx)">Agregar</a>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="col-sm-6 col-md-5 col-lg-5">
				<div class="card mb-3" v-if="genk.ok">
					<div class="card-body">
						<h5 class="card-title">COMPRA</h5>
						<p class="card-text">{{ genk.msg }}</p>
						<a
							href="#"
							class="btn btn-primary"
							title="Generar nueva compra"
							@click.prevent="nueva"
						>Nueva Compra</a>
					</div>
				</div>
				<div class="card mb-3" v-else>
					<div class="card-body">
						<form @submit.prevent="buscar_cliente" class="mb-2">
							<div class="form-check form-check-inline" v-for="(i, cidx) in opciones" :key="cidx">
								<input
									class="form-check-input"
									type="radio"
									name="clt_opcion"
									:value="i.id"
									:id="'tipo-'+i.id"
									v-model="bform.tipo"
								>
								<label class="form-check-label" :for="'tipo-'+i.id">{{ i.text }}</label>
							</div>
							<div class="input-group mb-3">
								<input
									type="text"
									class="form-control"
									placeholder="Buscar usuario"
									aria-label="Buscar usuario"
									aria-describedby="button-addon2"
									v-model="bform.texto"
								>
								<div class="input-group-append">
									<button
										class="btn btn-outline-secondary"
										type="submit"
										id="button-addon2"
									>Buscar</button>
								</div>
							</div>
						</form>
						
						<hr>
						
						<div class="mb-2" v-if="usrb">
							<p>Buscando...</p>
						</div>
						<div class="mb-2" v-else>
							<div class="form-check" v-for="(i, uidx) in usuarios" :key="uidx">
								<input
									class="form-check-input"
									type="radio"
									name="bazar_usuario"
									:value="i.id"
									:required="true"
									:id="'usr'+i.id"
									v-model="gform.usuario"
								>
								<label class="form-check-label" :for="'usr'+i.id">
									{{ i.nombre }} | <small>DPI: {{ i.dpi }}, NIT: {{ i.nit }}</small>
								</label>
							</div>
						</div>

						<div class="table-responsive mb-2">
							<table class="table table-sm">
								<thead>
									<tr>
										<th scope="col">#</th>
										<th scope="col">Cantidad</th>
										<th scope="col">Nombre</th>
										<th scope="col" class="text-right">Precio</th>
										<th></th>
									</tr>
								</thead>
								<tbody>
									<tr v-for="(i, idx) in gform.productos" :key="idx">
										<th scope="row">{{ idx+1 }}</th>
										<th>
											<input
												type="number"
												min="1"
												v-model="i.cantidad"
												style="width: 50px; font-size: 0.75em;"
											>
										</th>
										<td>{{ i.nombre }}</td>
										<td class="text-right">{{ (i.cantidad * parseFloat(i.precio)).toLocaleString('EN') }}</td>
										<td>
											<a href="#" style="color: red;" @click.prevent="removeItem(idx)"> x </a>
										</td>
									</tr>
								</tbody>
								<tfoot>
									<tr>
										<td colspan="3">TOTAL</td>
										<td class="text-right">{{ amountItem }}</td>
										<td></td>
									</tr>
								</tfoot>
							</table>
						</div>

						<input
							type="text"
							class="form-control form-control-sm mb-2"
							v-model="gform.telefono_contacto"
							id="telefonoContacto"
							placeholder="Teléfono de contacto">
						
						<input
							type="text"
							class="form-control form-control-sm mb-2"
							v-model="gform.direccion_entrega"
							id="direccionEntrega"
							placeholder="Dirección de entrega">

						<textarea
							class="form-control mb-2"
							v-model="gform.observaciones"
							rows="2"
							placeholder="Observaciones"
						></textarea>

						<button
							type="button"
							class="btn btn-primary btn-block mb-3"
							@click="generar"
							:disabled="genb"
						>
							<div class="spinner-border text-success" role="status" v-if="genb">
								<span class="sr-only">Loading...</span>
							</div>
							<span v-else>Aceptar</span>
						</button>

						<div class="alert alert-danger mb-3" role="alert" v-if="errors.length > 0">
							<ul>
								<li v-for="(i, idx) in errors" :key="idx">{{ i }}</li>
							</ul>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import axios from 'axios';

export default {
	name: 'BazarCompraDirecta',
	data: () => ({
		ops_producto: [
			{ id: 1, text: 'Código / SKU' },
			{ id: 2, text: 'Descripción' }
		],
		opciones: [
			{ id: 1, text: 'NIT' },
			{ id: 2, text: 'DPI' },
			{ id: 3, text: 'Nombre' }
		],
		bform: { tipo: 1, texto: '' },
		pform: { tipo: 1, texto: '' },
		gform: {
			usuario: '',
			productos: [],
			observaciones: '',
			telefono_contacto: '',
			direccion_entrega: ''
		},
		usuarios: [],
		usrb: false,
		productos: [],
		prob: false,
		errors: [],
		genb: false,
		genk: {
			msg: '',
			ok: false
		}
	}),
	methods: {
		buscar_cliente () {
			this.usrb = true
			this.usuarios = []
			this.gform.usuario = ''

			axios
			.get(this.UrlBase + '/catalogo/bazar_usuario', {params: this.bform})
			.then(res => {
				this.usuarios = res.data
				this.usrb = false

				if (this.usuarios.length === 1) {
					this.gform.usuario = this.usuarios[0].id
				}
			})
			.catch(err => {
				alert(err)
				this.usrb = false
			})
		},
		buscar_producto () {
			this.prob = true
			this.productos = []

			axios
			.get(this.UrlBase + '/catalogo/get_producto', {params: this.pform})
			.then(res => {
				this.productos = res.data.lista
				this.prob = false

				if (this.productos.length === 1) {
					this.addItem(0)
				}
			})
			.catch(err => {
				alert(err)
				this.prob = false
			})
		},
		addItem (idx) {
			let tmp = {...this.productos[idx]}
			tmp.cantidad = 1
			this.gform.productos.push(tmp)
		},
		removeItem (idx) {
			this.gform.productos.splice(idx, 1)
		},
		generar () {
			this.errors = []

			if (this.gform.usuario === '') {
				this.errors.push('Seleccione usuario')
			}

			if (this.gform.productos.length === 0) {
				this.errors.push('Agregue un artículo o producto')
			}

			if (this.errors.length === 0) {
				if (confirm('¿Seguro de continuar?')) {
					this.genb = true
					axios
					.post(this.UrlBase + '/compra/directa', this.gform)
					.then(res => {
						this.genb = false
						this.genk.msg = res.data.msg
						this.genk.ok = true
					})
					.catch(err => {
						if (err.response.status === 400) {
							if (err.response.data.errores) {
								err.response.data.errores.forEach(obj => {
									this.errors.push(obj.mensaje)
								})
							}
						} else {
							this.errors.push(err.response.statusText)
						}
						this.genb = false
					})
				}
			}
		},
		imagen (idx) {
			let pro = this.productos[idx]
			return pro.imagen === null ? '/' + pro.uimagen : this.UrlImgDrive+pro.imagen
		},
		nueva () {
			this.gform.usuario = ''
			this.gform.productos = []
			this.gform.observaciones = ''
			this.gform.telefono_contacto = ''
			this.gform.direccion_entrega = ''
			this.errors = []
			this.usuarios = []
			this.genk.ok = false
			this.genk.msg = ''
		}
	},
	computed: {
		amountItem () {
			let total = 0

			this.gform.productos.forEach(obj => {
				total += (obj.cantidad * parseFloat(obj.precio))
			})

			return total.toLocaleString('EN')
		}
	}
}
</script>